export type dashboardSitesDetail = {
    distanceUnits: any;
    id: string;
    name: string;
    startTime: Date;
    endTime: Date;
    timezone: string;
    assets: any[];
    token: string;
    localization: any[];
}

export type dashboardCreateAssetsResponse = {
    asset: {
        id: number;
        name: string;
        assetType: string;
        status: string;
        percentComplete: number;
        timestamp: Date;
    };
    uploadLocation: {
        endpoint: string;
        accessKey: string;
        secretAccessKey: string;
        sessionToken: string;
        bucket: string;
        prefix: string;
        region: string;
    };
    onComplete: {
        method: string;
        url: string;
        fields: any;
    };
}

export enum distanceUnitsEnum {
    METERS = "METERS",
    FEET = "FEET",
    US_SURVEY_FEET = "US_SURVEY_FEET"
}